import { ServerApi } from 'modules/api/server-api';

import { CommonEntity } from '@/models/BaseTypes';

export const fetchCompanyScopes = (api: ServerApi) => async () => {
  const response = await api.get('/dictionary/company-scopes');
  return response.data.scopes as CommonEntity[];
};
